import { useEffect } from 'react';
import styles from './TextContent.module.scss';

type Props = {
  text: string;
  onLoad: () => void;
};

const TextContent = ({ text, onLoad }: Props) => {
  useEffect(() => onLoad(), [onLoad]);
  return <div className={styles.text}>{text}</div>;
};

export default TextContent;
